/**
 * Strings for profile data sections (additional data, documents, social,
 * permissions, address card/list, contacts, emails). English is the source
 * of truth for all locales. Extracted during string extraction (batch C).
 *
 * Values are either a plain string (may contain `{placeholders}`) or a
 * plural object like `{ one: '{count} item', other: '{count} items' }`.
 */
export const dataSections = {
  // Shared empty state shown by the additional/documents/social sections when
  // the profile has no nationalities. "Personal Data" renders bold, so the
  // sentence is split into before/label/after parts.
  emptyState: {
    noNationalities: 'No nationalities configured.',
    addNationalityBefore: 'Add a nationality in the ',
    personalDataTab: 'Personal Data',
    addNationalityAfter: ' tab first.',
  },

  // niup-additional-data: nationality sub-tabs card with idiom + contact/email/address sections.
  additional: {
    idiomTitle: 'Idiom',
    idiomDesc: 'Select your idiom.',
    selectLanguage: 'Select language',
  },

  // niup-document-data: identity document fields per nationality.
  documents: {
    title: 'Documents',
    desc: 'Here you can add the details of your identity documents that you can choose to share with those representing you.',
    loadingFields: 'Loading fields...',
    noFields: 'No document fields available for this country.',
    enterPlaceholder: 'Enter {label}',
  },

  // niup-social-data: social page URL fields per nationality.
  social: {
    title: 'Socials',
    desc: 'Here you can enter your social pages information.',
    loadingFields: 'Loading fields...',
    noFields: 'No social fields available for this country.',
    enterUrl: 'Enter an URL',
  },

  // niup-permissions-data: people permissions and permission group sub-tabs.
  permissions: {
    peoplePermissions: 'People permissions',
    permissionGroup: 'Permission group',
    searchPlaceholder: 'Enter your search terms',
    noPeople: 'No people found.',
    noGroups: 'No permission groups found.',
    roleOwner: 'Owner',
    roleAdmin: 'Admin',
    roleUser: 'User',
    members: { one: '{count} member', other: '{count} members' },
    fields: { one: '{count} field', other: '{count} fields' },
  },

  // niup-address-card: single editable address card (type + fields + primary/remove controls).
  addressCard: {
    label: 'Address',
    primaryAddress: 'Primary address',
    setAsPrimary: 'Set as primary',
    removeAddress: 'Remove address',
    addressType: 'Address type',
    selectType: 'Select type',
    selectField: 'Select {label}',
    selectStateFirst: 'Select a state first',
    fieldRequired: '{label} is required',
  },

  // niup-address-list: list of address cards with add button.
  addresses: {
    title: 'Address',
    desc: 'Add one or more addresses.',
    addNew: 'Add new',
  },

  // niup-contact-list: editable phone contacts list.
  contacts: {
    title: 'Contact',
    desc: 'Add one or more contacts to your profile. You must set one as the default one.',
    phonePlaceholder: 'Enter your phone number',
    defaultContact: 'Default contact',
    setAsDefault: 'Set as default',
    removeContact: 'Remove contact',
  },

  // niup-email-list: editable emails list.
  emails: {
    title: 'Email',
    desc: 'Add one or more emails to your profile. You must set one as the default one.',
    addNew: 'Add new',
    emailPlaceholder: 'Enter your email',
    defaultEmail: 'Default email',
    setAsDefault: 'Set as default',
    removeEmail: 'Remove email',
  },
};
